<template>
  <div class="row p-3 g-3">
    <div class="col-12 mb-2 ps-0">
      <h5 class="card-title">Wie findet Ihre Veranstaltung statt?</h5>
      <p class="text-muted mb-0">
        Wählen Sie einen durchgehenden Zeitraum oder erfassen Sie den ersten konkreten Einzeltermin.
      </p>
    </div>

    <ErrorMessage v-if="showErrors" name="veranstaltung_terminart" class="font-bold my-2"/>

    <div class="col-12 col-lg-6">
      <label class="schedule-choice h-100" :class="{'schedule-choice--active': scheduleType === 'zeitraum'}">
        <Field
          type="radio"
          name="veranstaltung_terminart"
          value="zeitraum"
          v-model="surveyStore.data.veranstaltung.terminart"
          class="form-check-input"
        />
        <span>
          <strong class="d-block">Durchgehender Zeitraum</strong>
          <small class="text-muted">Zum Beispiel ein Festivalwochenende oder eine Ausstellung.</small>
        </span>
      </label>
    </div>
    <div class="col-12 col-lg-6">
      <label class="schedule-choice h-100" :class="{'schedule-choice--active': scheduleType === 'einzeltermin'}">
        <Field
          type="radio"
          name="veranstaltung_terminart"
          value="einzeltermin"
          v-model="surveyStore.data.veranstaltung.terminart"
          class="form-check-input"
        />
        <span>
          <strong class="d-block">Konkrete Einzeltermine</strong>
          <small class="text-muted">Hier erfassen Sie zunächst nur den ersten Termin.</small>
        </span>
      </label>
    </div>

    <template v-if="scheduleType === 'zeitraum'">
      <div class="col-12 col-lg-6">
        <label class="form-label" for="veranstaltung_termin">Startdatum</label>
        <Field
          id="veranstaltung_termin"
          type="date"
          name="veranstaltung_termin"
          class="form-control"
          :min="min"
          :max="max"
          :class="{'is-invalid': errors.veranstaltung_termin}"
          v-model="surveyStore.data.veranstaltung.termin"
        />
        <ErrorMessage v-if="showErrors" name="veranstaltung_termin" class="invalid-feedback"/>
      </div>
      <div class="col-12 col-lg-6">
        <label class="form-label" for="veranstaltung_endtermin">Enddatum</label>
        <Field
          id="veranstaltung_endtermin"
          type="date"
          name="veranstaltung_endtermin"
          class="form-control"
          :min="surveyStore.data.veranstaltung.termin || min"
          :max="max"
          :class="{'is-invalid': errors.veranstaltung_endtermin}"
          v-model="surveyStore.data.veranstaltung.endtermin"
        />
        <ErrorMessage v-if="showErrors" name="veranstaltung_endtermin" class="invalid-feedback"/>
      </div>
    </template>

    <template v-if="scheduleType === 'einzeltermin'">
      <div class="col-12 col-lg-6">
        <label class="form-label" for="veranstaltung_termin">Datum des ersten Termins</label>
        <Field
          id="veranstaltung_termin"
          type="date"
          name="veranstaltung_termin"
          class="form-control"
          :min="min"
          :max="max"
          :class="{'is-invalid': errors.veranstaltung_termin}"
          v-model="surveyStore.data.veranstaltung.termin"
        />
        <ErrorMessage v-if="showErrors" name="veranstaltung_termin" class="invalid-feedback"/>
      </div>
      <div class="col-12 col-lg-6">
        <label class="form-label" for="veranstaltung_uhrzeit">Uhrzeit</label>
        <Field
          id="veranstaltung_uhrzeit"
          type="time"
          name="veranstaltung_uhrzeit"
          class="form-control"
          :class="{'is-invalid': errors.veranstaltung_uhrzeit}"
          v-model="surveyStore.data.veranstaltung.uhrzeit"
        />
        <ErrorMessage v-if="showErrors" name="veranstaltung_uhrzeit" class="invalid-feedback"/>
      </div>
      <div class="col-12">
        <p class="alert alert-info mb-0">
          Weitere Einzeltermine können Sie nach dem Anlegen in der Veranstaltung ergänzen. Ab dem zweiten Termin ist dies ein Premium-Feature.
        </p>
      </div>
    </template>
  </div>
</template>

<script>
import {useSurveyStore} from "../../../stores/survey";
import {Field, ErrorMessage} from 'vee-validate';
import dayjs from "dayjs";

export default {
  components: {Field, ErrorMessage},
  setup() {
    return {surveyStore: useSurveyStore()}
  },
  data() {
    return {
      min: dayjs().format('YYYY-MM-DD'),
      max: dayjs().add(1, 'year').format('YYYY-MM-DD'),
    }
  },
  props: {
    errors: Object,
    showErrors: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    scheduleType() {
      return this.surveyStore.data.veranstaltung.terminart
    },
  },
}
</script>

<style scoped>
.schedule-choice {
  display: flex;
  gap: 0.85rem;
  align-items: flex-start;
  padding: 1rem;
  border: 2px solid #d9d9e2;
  background: #fff;
  cursor: pointer;
}

.schedule-choice--active {
  border-color: #664caf;
  background: #f7f5fd;
}
</style>
